<template>
	<v-app>
		<v-main>
			<router-view></router-view>
		</v-main>
	</v-app>
</template>

<script>
	export default {
		name: 'App',

	}

</script>

<style>
/* 桌面端：固定高度，禁止滚动条 */
@media (min-width: 769px) {
  html, body {
    overflow-x: auto !important;
    overflow-y: hidden !important;
  }
}
/* 手机端：不设任何overflow，浏览器原生处理滚动和缩放 */
</style>
